module.exports = __webpack_public_path__ + "img/otherrz.777281b0.png";